import { enDashbord } from './types'

export const lockAnimation = (value: boolean) => ({
  type: enDashbord.LOCKANIMATION,
  value,
})
